// Shared helpers for product-event destinations.
// Extracted from containers/Triggers/{addTrigger,triggerCard}.tsx so the
// Product Events screen and the trigger components can't drift apart.

// custom_properties holds either a bare view-list id (legacy) or JSON
// {"view_list":"…","cart_list":"…"}. Support never types JSON — the UI
// parses/serializes both shapes.
export const parseListConfig = (cp: any) => {
  const raw = String(cp || '').trim();
  if (raw.startsWith('{')) {
    try {
      const obj = JSON.parse(raw);
      return { viewList: String(obj.view_list || ''), cartList: String(obj.cart_list || '') };
    } catch (e) { /* fall through to bare-string form */ }
  }
  return { viewList: raw, cartList: '' };
};

export const serializeListConfig = (viewList: any, cartList: any) => {
  const v = String(viewList || '').trim();
  const c = String(cartList || '').trim();
  if (c) {
    const obj: any = {};
    if (v) obj.view_list = v;
    obj.cart_list = c;
    return JSON.stringify(obj);
  }
  return v;
};

// The panel backend returns VARBINARY columns (api_key, custom_properties) as
// raw Buffer JSON ({type:'Buffer',data:[...]}). Decode to a string before the
// inputs render it — otherwise the UI shows "[object Object]" and a Save would
// overwrite the real stored value with that literal string (which is exactly
// how old webhook rows ended up with junk api_key values).
export const decodeVarbinary = (v: any) => {
  if (v == null) return '';
  if (typeof v === 'object') {
    if (v.type === 'Buffer' && Array.isArray(v.data)) {
      try { return new TextDecoder().decode(new Uint8Array(v.data)); } catch (e) { return ''; }
    }
    return '';
  }
  return String(v);
};

// Macros the product pipeline fills at dispatch. Keys ARE the macro names.
export const productMacros = {
  email: 'Email Address',
  hashEmail: 'Hash Email',
  timestamp: 'Timestamp',
  eventType: 'Event Type',
  productName: 'Product Name',
  productPrice: 'Product Price',
  productImage: 'Product Image',
  productUrl: 'Product URL',
  productId: 'Product ID',
  quantity: 'Quantity',
};

export const isPaused = (d: any) => Number(d && d.paused) === 1;

// destination.url is VARCHAR(2000) in smrcmain and in the Redshift copy.
// Longer URLs are rejected by the database, so stop them before saving.
export const MAX_DESTINATION_URL = 2000;
export const urlLengthError = (url: any) => {
  const n = String(url || '').length;
  return n > MAX_DESTINATION_URL
    ? `This URL is ${n} characters; the maximum is ${MAX_DESTINATION_URL}.`
    : null;
};
export const SAVE_FAILED_MESSAGE = 'Could not save. Nothing was changed. Please try again or tell support.';
